import { useDispatch,useSelector } from "react-redux";
import React from "react";
// project imports
import { Grid, Button,
  TextField,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem, } from "@mui/material";
import PageHeader from "../../ui-component/cards/PageHeader";
import { gridSpacing } from "../../store/constant";
import DealerServices from "../../services/DealerServices";
import { useEffect, useState } from "react";
import DynamicDatatables from "../../datatables/DynamicDatatables";
import { dealerListColumn } from "../../datatables/rowsColumn";
import {dealerList} from "../../actions/commonDataActions";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getRole } from '../../helper';
import { useTranslation } from 'react-i18next';
import tableTheme from "../../ui-component/customTableUi";
import { ThemeProvider } from "@mui/material/styles";
import FilterListIcon from "@mui/icons-material/FilterList";
import DownloadIcon from "@mui/icons-material/Download";
import ClearIcon from "@mui/icons-material/Clear";
import PrintIcon from "@mui/icons-material/Print";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const DealerList = () => {
  const { t } = useTranslation();
  const [load, setLoad] = useState(false);
  const [updateStore,setUpdateStore]=useState(false)

const [dealerData, setDealerData] = useState([]);

const [search, setSearch] = useState("");

const [openFilter, setOpenFilter] = useState(false);

const defaultFilters = {
  dealer_id: "",
  company_name: "",
  name: "",
  email: "",
  phone_no: "",
  address: "",
  manufacturer_state: "",
  status: "",
  gstnnumber: "",
};

const [filters, setFilters] = useState(defaultFilters);
  const dispatch = useDispatch();
  const dealers=useSelector((state)=>state.dealer.list);
  
  const role = getRole();

  // useEffect(() => {
  //   if(dealers.length<1 && !updateStore){
  //     const retrievePosts = async () => {
  //       const retriveData = await DealerServices.dealerList();
  //       setDealerData(retriveData.data);
  //       dispatch(dealerList(retriveData.data))
  //       setLoad(true);
  //       setUpdateStore(true);
  //     };
  //     retrievePosts();
  //   }
  // }, [updateStore,dispatch]);

  useEffect(() => {
  fetchDealerList(defaultFilters);
}, []);


const fetchDealerList = async (payload = defaultFilters) => {
  try {
    setLoad(false);

    const response = await DealerServices.findDealer(payload);

    const data = response?.data || [];

    setDealerData(Array.isArray(data) ? data : []);

    setLoad(true);

  } catch (err) {
    console.log(err);

    setDealerData([]);

    setLoad(true);
  }
};

useEffect(() => {

  const timer = setTimeout(() => {

    fetchDealerList({
      ...filters,
      company_name: search,
    });

  },500);

  return ()=>clearTimeout(timer);

},[search]);

const applyFilter = () => {
  fetchDealerList(filters);
  setOpenFilter(false);
};

const clearFilter = () => {

  setFilters(defaultFilters);

  setSearch("");

  fetchDealerList(defaultFilters);

};

const isFilterApplied = Object.values(filters).some(
  value => value !== ""
);

const downloadExcel = async () => {

  const payload = isFilterApplied
    ? filters
    : defaultFilters;

  const response = await DealerServices.findDealer(payload);

  const data = response.data || [];

  const worksheet = XLSX.utils.json_to_sheet(data);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Dealers");

  const excelBuffer = XLSX.write(workbook,{
    bookType:"xlsx",
    type:"array"
  });

  saveAs(
    new Blob([excelBuffer]),
    "Dealers.xlsx"
  );

};

const printDealerList = async () => {
  try {
    const payload = isFilterApplied
      ? filters
      : defaultFilters;

    const response = await DealerServices.findDealer(payload);

    const data = response?.data || [];

    if (!Array.isArray(data) || data.length === 0) {
      alert("No data found");
      return;
    }

    const html = `
      <html>
      <head>
        <title>Dealer List</title>
        <style>
          body{
            font-family: Arial, sans-serif;
            padding:20px;
          }

          h2{
            text-align:center;
            margin-bottom:20px;
          }

          table{
            width:100%;
            border-collapse:collapse;
          }

          th,td{
            border:1px solid #000;
            padding:8px;
            font-size:12px;
            text-align:left;
          }

          th{
            background:#f2f2f2;
          }
        </style>
      </head>

      <body>

        <h2>Dealer List</h2>

        <table>
          <thead>
            <tr>
              <th>Company Name</th>
              <th>Dealer Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Address</th>
              <th>Manufacturer State</th>
              <th>GST Number</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            ${data
              .map(
                (item) => `
                <tr>
                  <td>${item.company_name || ""}</td>
                  <td>${item.name || ""}</td>
                  <td>${item.email || ""}</td>
                  <td>${item.phone_no || ""}</td>
                  <td>${item.address || ""}</td>
                  <td>${item.manufacturer_state || ""}</td>
                  <td>${item.gstnnumber || ""}</td>
                  <td>${item.status || ""}</td>
                </tr>
              `
              )
              .join("")}
          </tbody>

        </table>

      </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    printWindow.focus();
    printWindow.print();
    printWindow.close();

  } catch (err) {
    console.log(err);
  }
};

const handleFilterChange = (field, value) => {
  setFilters((prev) => ({
    ...prev,
    [field]: value,
  }));
};

  const actionColumn = [
    {
      name: "Action",
      label: t('common.action'),
      options: {
        filter: false,
        customBodyRender: (value, tableMeta) => {
          // Note: tableMeta.rowData contains raw values from API (timestamps, where present, are in GMT/UTC).
          return (
            <div className="cellAction" style={{ display: "flex" }}>
              <Link
                to={`/user/detail/dealer/${tableMeta.rowData[0]}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">
                  <VisibilityIcon />
                </div>
              </Link>
            </div>
          );
        },
      },
    },
  ];
  const columns = role === 'superadmin' || role === 'stateadmin' 
  ? dealerListColumn.concat(actionColumn) 
  : dealerListColumn;
  
 return (
  <>
    <Grid container spacing={gridSpacing}>

      <Grid item xs={12}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          spacing={2}
          sx={{ mb: 2 }}
        >
          <TextField
            size="small"
            placeholder="Search Company Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ width: 300 }}
          />

          <Stack direction="row" spacing={2}>
            <Button
  variant="outlined"
  startIcon={<FilterListIcon />}
  onClick={() => setOpenFilter((prev) => !prev)}
>
  Filter
</Button>

            <Button
              variant="outlined"
              color="success"
              startIcon={<DownloadIcon />}
              onClick={downloadExcel}
            >
              Download
            </Button>

            <Button
  variant="outlined"
  color="primary"
  startIcon={<PrintIcon />}
  onClick={printDealerList}
>
  Print
</Button>

            <Button
              variant="outlined"
              color="error"
              startIcon={<ClearIcon />}
              onClick={clearFilter}
            >
              Clear
            </Button>

          </Stack>
        </Stack>
            {openFilter && (
  <Grid
    container
    spacing={2}
    sx={{
      mb: 2,
      mt:1,
      p: 2,
      border: "1px solid #ddd",
      borderRadius: 2,
      backgroundColor: "#fafafa",
    }}
  >
    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Company Name"
        value={filters.company_name}
        onChange={(e) =>
          handleFilterChange("company_name", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Dealer Name"
        value={filters.name}
        onChange={(e) =>
          handleFilterChange("name", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Email"
        value={filters.email}
        onChange={(e) =>
          handleFilterChange("email", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Phone"
        value={filters.phone_no}
        onChange={(e) =>
          handleFilterChange("phone_no", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Address"
        value={filters.address}
        onChange={(e) =>
          handleFilterChange("address", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="Manufacturer State"
        value={filters.manufacturer_state}
        onChange={(e) =>
          handleFilterChange("manufacturer_state", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        fullWidth
        label="GST Number"
        value={filters.gstnnumber}
        onChange={(e) =>
          handleFilterChange("gstnnumber", e.target.value)
        }
      />
    </Grid>

    <Grid item xs={12} md={3}>
      <TextField
        select
        fullWidth
        label="Status"
        value={filters.status}
        onChange={(e) =>
          handleFilterChange("status", e.target.value)
        }
      >
        <MenuItem value="">All</MenuItem>
        <MenuItem value="true">Active</MenuItem>
        <MenuItem value="false">Inactive</MenuItem>
      </TextField>
    </Grid>

    <Grid item xs={12}>
      <Stack direction="row" justifyContent="flex-end" spacing={2}>
        <Button
          variant="outlined"
          onClick={clearFilter}
        >
          Clear
        </Button>

        <Button
          variant="contained"
          onClick={applyFilter}
        >
          Apply Filter
        </Button>
      </Stack>
    </Grid>
  </Grid>
)}
        <ThemeProvider theme={tableTheme}>
          {load && (
            <DynamicDatatables
              tableTitle={t("dealer.listTitle")}
              rows={dealerData}
              columns={columns}
              helperText="Timestamps are in GMT/UTC."
              options={{
                search: false,
                filter: false,
                print: false,
                download: false,
                selectableRows: "none",
                viewColumns: false,
              }}
            />
          )}
        </ThemeProvider>
      </Grid>
    </Grid>

    {/* Filter Dialog */}

    {/* <Dialog
      open={openFilter}
      onClose={() => setOpenFilter(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Filter Dealers</DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Company Name"
              value={filters.company_name}
              onChange={(e) =>
                handleFilterChange("company_name", e.target.value)
              }
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Dealer Name"
              value={filters.name}
              onChange={(e) =>
                handleFilterChange("name", e.target.value)
              }
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Email"
              value={filters.email}
              onChange={(e) =>
                handleFilterChange("email", e.target.value)
              }
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Phone"
              value={filters.phone_no}
              onChange={(e) =>
                handleFilterChange("phone_no", e.target.value)
              }
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Address"
              value={filters.address}
              onChange={(e) =>
                handleFilterChange("address", e.target.value)
              }
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="State"
              value={filters.state}
              onChange={(e) =>
                handleFilterChange("state", e.target.value)
              }
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="GST Number"
              value={filters.gstnnumber}
              onChange={(e) =>
                handleFilterChange("gstnnumber", e.target.value)
              }
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              select
              fullWidth
              label="Status"
              value={filters.status}
              onChange={(e) =>
                handleFilterChange("status", e.target.value)
              }
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="true">Active</MenuItem>
              <MenuItem value="false">Inactive</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpenFilter(false)}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={applyFilter}
        >
          Apply Filter
        </Button>
      </DialogActions>
    </Dialog> */}
  </>
);
};

export default DealerList;
